
const API_ENDPOINTS = [
  'get',
  'update',
]

const fetcher = async (endpoint, options) => await (await fetch(`${HH_QUIZ.api}/${endpoint}`, options)).json()
const api = {}
console.log('hola')

API_ENDPOINTS.forEach((name) => {
  api[name] = async (q) => {
    const response = await fetcher(name, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: typeof q == 'string' ? q : JSON.stringify(q),
    })

    if (Object.keys(response).length === 0 || Object.keys(response).length === 1 && response.status) {
      response.status = 404
      response.error = 'Not Found'
    }

    if (response.shopifyError) {
      response.status = 500
      response.error = response.shopifyError?.[0]?.message
    }

    if (HH_QUIZ.api.includes('localhost') || response.status !== 200) {
      console[response.status === 200 ? 'log' : 'error'](`${response.status === 200 ? 'Success' : 'Error'} fetching ${HH_QUIZ.api}/${name}`, {
        endpoint: name,
        response
      })
    }

    return response
  }
})

module.exports = api
